export enum Locales {
  EN = 'en-CA',
  FR = 'fr-CA'
}
